import { $notificationsApi } from '@/http/OpenAPI/clients/react-query/notifications';

export const useMarkNotificationAsReadMutation = () => {
  return $notificationsApi.useMutation(
    'patch',
    '/api/notifications/Notification/UpdateReadStatus'
  );
};
